import { useEffect, useState } from 'react';
import Head from 'next/head';
import reactHtmlParser from 'react-html-parser';
import Image from 'next/image';

import Cookies from 'js-cookie';

import { STRAPI_URL } from '../config/endPoints';
import SideNav from '../components/sideNav/SideNav';
import DocsHeader from '../components/DocsHeader';
import Footer from '../components/Footer';
import { removeSpacesFromId } from '../components/utils/keHelper';
import useWindowDimensions from '../components/utils/ScreenSize';
import { useAuth, logout } from '../components/hook/useAuth';

import Login from '../components/dialog/Login/Login';
import Signup from '../components/dialog/Signup/Signup';
import ResetPassword from '../components/dialog/ResetPassword/ResetPassword';
import NewPassword from '../components/dialog/NewPassword/NewPassword';

const Blog = (props) => {
  //console.log('props at slug :>> ');
  const { width } = useWindowDimensions();
  const { blog, blogs, currentSlug } = props;
  const blogData = props.blog.results[0];
  const { content, metaTitle, metaDescription, isOldDoc } = blogData;
  const [openSideNav, setOpenSideNav] = useState(false);

  const [haveToken, setHaveToken] = useState(false);

  const {
    token,
    user,
    isShowLogin,
    isShowSignup,
    isShowNewPassword,
    isShowResetPassword,
    resetPasswordCode,
    setShowLogin,
    setShowSignup,
    setShowNewPassword,
    setShowResetPassword,
  } = useAuth();

  const [isUserLoggedIn, setIsUserLoggedIn] = useState(false);

  const resetPasswordProc = () => {
    setShowLogin(false);
    setShowResetPassword(true);
  };
  const registerSuccessProc = () => {
    setShowSignup(false);
  };

  useEffect(() => {
    if (user) {
      setIsUserLoggedIn(true);
    } else {
      setIsUserLoggedIn(false);
    }
  }, [user]);

  useEffect(() => {
    getCookiesData();
  }, []);

  const getCookiesData = () => {
    if (typeof window !== 'undefined') {
      if (Cookies.get('token')) {
        setHaveToken(true);
      }
    }
  };

  //console.log(blogData, 'blogData');
  const transform = (node, index) => {
    if (node.name === 'h3' || node.name === 'h2') {
      const text = node.children[0].data;

      return (
        <h3 key={index} id={removeSpacesFromId(text)} style={{ scrollMarginTop: '90px' }}>
          {text}
        </h3>
      );
    }

    if (node.name == 'img') {
      // return <Image  width="100%" height="100%"/>;
      if (isOldDoc) {
        return (
          <img
            src={`https://mendelgen.com/${node.attribs.src}`}
            alt=""
            key={index}
            className={node.attribs.class}
          />
        );
      } else {
        if (node.attribs.src.includes('uploads')) {
          return (
            <img
              src={`https://strapi.mendelgen.com/${node.attribs.src}`}
              alt=""
              className="fullScreenshot"
              key={index}
            />
          );
        }
      }
    }
  };
  return (
    <>
      <Head>
        <title>{metaTitle}</title>
        <meta name="description" content={metaDescription} />
      </Head>
      <DocsHeader
        openSideNav={openSideNav}
        setOpenSideNav={setOpenSideNav}
        haveToken={haveToken}
        setShowLogin={setShowLogin}
        setShowSignup={setShowSignup}
      />
      <div className="slugContainer">
        <SideNav
          blogs={blogs.results}
          currentSlug={currentSlug}
          openSideNav={openSideNav}
          setOpenSideNav={setOpenSideNav}
          haveToken={haveToken}
          setShowLogin={setShowLogin}
          setShowSignup={setShowSignup}
        />
        <div
          className="htmlData"
          style={width < 800 ? (openSideNav ? { position: 'fixed', left: '80%' } : null) : null}
        >
          {reactHtmlParser(content, { transform })}
        </div>
      </div>
      {!openSideNav && <Footer isSlug={true} />}
      <Login
        showModal={isShowLogin}
        closeProc={() => {
          setShowLogin(false);
        }}
        resetPassword={resetPasswordProc}
      />
      <Signup
        showModal={isShowSignup}
        closeProc={() => {
          setShowSignup(false);
        }}
        successProc={registerSuccessProc}
      />
      <ResetPassword
        showModal={isShowResetPassword}
        closeProc={() => {
          setShowResetPassword(false);
        }}
      />
      <NewPassword
        showModal={isShowNewPassword}
        closeProc={() => {
          props.history.push('/');
          setShowNewPassword(false, '');
        }}
        resetCode={resetPasswordCode}
        successProc={() => {
          setShowNewPassword(false, '');
          props.history.push('/');
        }}
      />
    </>
  );
};

export async function getStaticProps(context) {
  //console.log(context.params.slug);
  const slug = context.params.slug;
  //console.log('slug :>> ', slug);
  const res = await fetch(`${STRAPI_URL}docs/slug/${slug}`);
  const blogList = await fetch(`${STRAPI_URL}docsIdAndTitle`);

  
  if (!blogList.ok) {
    console.error('Failed to fetch blog list', blogList.statusText);
    return { paths: [], fallback: false };
}

  const blog = await res.json();
  const blogs = await blogList.json();
  //console.log(blogList)
  console.log('STARTING')
  console.log(blog)
  if (blog.results.length === 0) {
    return {
      notFound: true,
    };
  } else {
    return {
      props: {
        blog,
        blogs,
        currentSlug: slug,
      },
    };
  }
  console.log(props);
}


export async function getStaticPaths() {
    //let data = await getFranchises();
    const blogList = await fetch(`${STRAPI_URL}docsIdAndTitle`);

    //console.log("Blog list response:", blogList);

    let data = await blogList.json();
    console.log("Blog list data:", data);

    // Get the paths we want to pre-render based on posts
    const paths = data.results.map(blog => ({
        params: {slug: blog.slug},
    }));

    //console.log(paths)

    // We'll pre-render only these paths at build time.
    return {paths, fallback: false}
}

export default Blog;
